// @flow

import React, { Component } from 'react';

import ReactPlayer from 'react-player';


type T_MonitorHelpProps = {
  title: string,
  video: string,
  last : boolean
};



export default class MonitorHelp extends Component<T_MonitorHelpProps> {
  render() {
    return (
      <div className={this.props.last ? 'MonitorHelp_bottom' : 'MonitorHelp'}>
        <h3 id={this.props.video.replace(/\./g, '_')} className='question'>
          {this.props.title}
        </h3>
        
        <div className='screenshot-holder'>
          <a>
            <div className='monitor'>
              <ReactPlayer width='665' height='415' url={`vid/${this.props.video}`} controls={true} />
            </div>
          </a>
        </div>
        
        <div>
          Haz clic en para ver el video.
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/MonitorHelp.jsx